import { createContext, useContext, useState } from "react"
import { useSelector } from "react-redux"

export type Store = {
  id: string
  name: string
  city: string
  isActive: boolean
}

type StoreContextType = {
  stores: Store[]
  currentStore: Store | null
  setCurrentStore: (store: Store) => void
  addStore: (store: Store) => void
}

const StoreContext = createContext<StoreContextType | null>(null)

export function StoreProvider({ children }: { children: React.ReactNode }) {
  const userdata = useSelector((state: any) => state.UserReducer.userdata);

  const [stores, setStores] = useState<any[]>([
    // {
    //   id: "store_1",
    //   name: "Boutique Plateau",
    //   city: "Abidjan",
    //   isActive: true,
    // },
  ])

  const [currentStore, setCurrentStore] = useState<Store | null>(userdata.store)

  const addStore = (store: Store) => {
    setStores(prev => [...prev, store])
    if (!currentStore) setCurrentStore(store)
  }

  return (
    <StoreContext.Provider
      value={{ stores, currentStore, setCurrentStore, addStore }}
    >
      {children}
    </StoreContext.Provider>
  )
}

export function useStore() {
  const ctx = useContext(StoreContext)
  if (!ctx) {
    throw new Error("useStoreContext must be used inside StoreProvider")
  }
  return ctx
}
